// TODO: define enum for modal types

/**
 * Represents the configuration options for a modal dialog.
 *
 * @property {boolean} modalOpen - Indicates whether the modal is currently open or closed
 * @property {string | null} modalType - The type identifier of the modal, or null if no modal is active
 */
export type ModalOptions = {
  modalOpen: boolean
  modalType: string | null
}

export const initialModalOptions: ModalOptions = {
  modalOpen: false,
  modalType: null,
}
